import { makeStyles } from '@material-ui/core/styles'

const useStyles = (styles, props) => makeStyles(styles)(props)

export default useStyles
